import { Star } from "lucide-react";

export default function StarRating({ value = 0, max = 5, onChange, size = 22, readOnly = false, testId = "star-rating" }) {
  return (
    <div className="flex items-center gap-1" data-testid={testId}>
      {Array.from({ length: max }).map((_, i) => {
        const filled = i < value;
        return (
          <button
            key={i}
            type="button"
            disabled={readOnly}
            onClick={() => !readOnly && onChange && onChange(i + 1)}
            data-testid={`${testId}-star-${i + 1}`}
            className={`transition-transform duration-150 ${readOnly ? "cursor-default" : "hover:scale-125 active:scale-95 cursor-pointer"}`}
            aria-label={`Rate ${i + 1}`}
          >
            <Star
              size={size}
              strokeWidth={1.5}
              className={filled ? "fill-[#FFCC00] text-[#FFCC00]" : "fill-transparent text-gray-300"}
            />
          </button>
        );
      })}
    </div>
  );
}
